export default __webpack_public_path__ + "static/lamina-8536422367b254d328a14aedf1043595.png";